import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFileContract,
  faContactCard,
  faShieldAlt,
  faEnvelope,
  faPhone
} from '@fortawesome/free-solid-svg-icons'

const Footer = () => {
  const { t } = useTranslation('footer')
  const location = useLocation()
  
  // Function to check if a link is active
  const isActive = (path) => {
    return location.pathname.includes(path) ? 'text-primary' : 'text-gray-400 hover:text-primary';
  }
  
  return (
    <footer className="bg-gray-900 py-12 border-t border-gray-800 mt-12">
      <div className="container mx-auto px-4">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-10">
          {/* Company info section */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-6">
              <img 
                src="/assets/images/logo.png" 
                alt="PathConnect" 
                className="h-10 mr-3"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                }} 
              />
              <h3 className="text-xl font-bold text-white">PathConnect</h3>
            </div>
            <p className="text-gray-400 mb-4">
              {t('companyDescription')}
            </p>
          </div>
          
          {/* Contact info section */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">{t('contact.title')}</h4>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-400">
                <FontAwesomeIcon icon={faEnvelope} className="mr-3 text-primary/80 w-5" />
                <a href={`mailto:${t('contact.email')}`} className="hover:text-primary transition-colors duration-300">
                  {t('contact.email')}
                </a>
              </li>
              <li className="flex items-center text-gray-400">
                <FontAwesomeIcon icon={faPhone} className="mr-3 text-primary/80 w-5" />
                <a href={`tel:${t('contact.phone')}`} className="hover:text-primary transition-colors duration-300">
                  {t('contact.phone')}
                </a>
              </li>
            </ul>
          </div>
          
          {/* Quick links section - kept heading but removed links */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold text-white mb-4">{t('services.title')}</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">
                {t('services.consulting')}
              </li>
              <li className="text-gray-400">
                {t('services.hosting')}
              </li>
              <li className="text-gray-400">
                {t('services.development')}
              </li>
            </ul>
          </div>
          
          {/* Legal links section */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-semibold text-white mb-4">{t('legal.title')}</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/agb"
                  className={`flex items-center transition-colors duration-300 ${isActive('/agb')}`}
                >
                  <FontAwesomeIcon icon={faFileContract} className="mr-2 w-5" />
                  <span>{t('legal.agb')}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/impressum"
                  className={`flex items-center transition-colors duration-300 ${isActive('/impressum')}`}
                >
                  <FontAwesomeIcon icon={faContactCard} className="mr-2 w-5" />
                  <span>{t('legal.impressum')}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className={`flex items-center transition-colors duration-300 ${isActive('/privacy')}`}
                >
                  <FontAwesomeIcon icon={faShieldAlt} className="mr-2 w-5" />
                  <span>{t('legal.privacy')}</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright section */}
        <div className="text-center text-gray-400 text-sm">
          © {new Date().getFullYear()} PathConnect GmbH
        </div>
      </div>
    </footer>
  )
}

export default Footer